<div [id]="name" class="barChart" ></div>
